import { isPlatformBrowser } from '@angular/common'
import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { inject, PLATFORM_ID } from '@angular/core'

import { Observable } from 'rxjs'

export function giftCardInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const platformId = inject(PLATFORM_ID)

  let card: null | string = null
  if (isPlatformBrowser(platformId)) {
    card = localStorage.getItem('giftCard')
  }

  if (card) {
    return next(req.clone({ setHeaders: { Code: card } }))
  }

  return next(req)
}
